import { render, staticRenderFns } from "./provinsi.vue?vue&type=template&id=6aa22433&"
import script from "./provinsi.vue?vue&type=script&lang=js&"
export * from "./provinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports